exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.preview_modal__wrapper--ET67u {\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n    padding: 20px;\r\n    position: relative;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"wrapper": "preview_modal__wrapper--ET67u"
};